import AccountLayout from "../layouts/AccountLayout"
import './../styles/payment.css';
import { PiBankFill } from "react-icons/pi";
import { BiSolidCreditCardFront } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { FaBolt } from "react-icons/fa";

export const Payment = () => {
    const navigate = useNavigate();

    return (
        <AccountLayout title={'Nạp tiền'}>
            <div className="user-payment-container">
                <section className="payment-hero">
                    <p className="payment-badge">Recharge Hub</p>
                    <h2>Chọn phương thức nạp tiền</h2>
                    <p className="payment-description">Nạp nhanh, an toàn và theo dõi trạng thái giao dịch theo thời gian thực.</p>
                </section>

                <section className="payment-method-grid">
                    <article className="deposit-button-container">
                        <p className="payment-method-title">
                            <PiBankFill className="payment-method-icon" />
                            Nạp tiền qua ngân hàng
                        </p>
                        <span className="payment-method-subtitle">Hỗ trợ quét QR và chuyển khoản thủ công.</span>
                        <button onClick={() => navigate('/payment/bank-transfer')} className="user-deposit-button">
                            Tiếp tục
                        </button>
                    </article>

                    <article className="deposit-button-container">
                        <p className="payment-method-title">
                            <BiSolidCreditCardFront className="payment-method-icon" />
                            Nạp tiền qua thẻ cào
                        </p>
                        <span className="payment-method-subtitle">Nạp trực tiếp bằng mã thẻ game/viễn thông.</span>
                        <button onClick={() => navigate('/payment/card-transfer')} className="user-deposit-button">
                            Tiếp tục
                        </button>
                    </article>
                </section>

            </div>
        </AccountLayout>
    )
}
